// Cookies are stored as a single string separated by semicolons. Ex. "cookie_name=cookie_value; another_cookie_name=another_cookie_value"
// This function returns the cookie value when passed in a name
export const getCookieValue = (name: string) => {
  const maybeCookieMatch = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return maybeCookieMatch ? maybeCookieMatch[2] : null;
};
